// extracted by mini-css-extract-plugin
export default {"label":"EmailInput_label__uBC5q","content":"EmailInput_content__Tgto0","icon":"EmailInput_icon__G9+nx","input":"EmailInput_input__UYDZU"};